import React, { useState } from "react";
import { Row, Col, Card, CardBody, Button, Input } from "reactstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import GenericTooltip from "../../atoms/generic-tooltip";
import T from "../../atoms/translate";
import { t, showToast } from "../../../utils/utils";
import ConfirmationModal from "../../organisms/confirmation-modal";

const ProjectRoleCard = ({
  currentRoles,
  newRole,
  createRole,
  deleteRole,
  name,
}) => {
  const [input, setInput] = useState("");
  const [confirmDelete, setConfirmDelete] = useState(false);

  return (
    <>
      {newRole ? (
        <Col xs="6" md="3" lg="2" className="mb-3">
          <Card
            className={"box-shadow rounded-xg border-gris-100"}
            style={{ height: "170px" }}
          >
            <CardBody className="px-3 pb-1 pt-2">
              <Row className="mt-2">
                <Col xs="12" className="my-2">
                  <h1 className="fw-500 font-size-08 mb-3">
                    <T i18nKey="agregarRol" />
                  </h1>
                  <Input
                    value={input}
                    onChange={(e) => setInput(e.target.value.toUpperCase())}
                    placeholder={t("placeholderNombreRol")}
                  />
                  <span className="font-size-07">
                    <T i18nKey="nombreRolMinimo3Caracteres" />
                  </span>
                </Col>
                <Col xs="12" className="mb-2 text-center">
                  <Button
                    disabled={!input || input.length < 3}
                    size="sm"
                    color="primary"
                    onClick={() => {
                      if (Array.isArray(currentRoles) && currentRoles.some((role) => role === input)) {
                        showToast(t("crearRolErrorRolYaExiste"), "error");
                      } else {
                        setInput("");
                        createRole(input);
                      }
                    }}
                  >
                    <T i18nKey="crear" />
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      ) : (
        <Col xs="6" md="3" lg="2" className="mb-3">
          <Card
            className={
              "h-100 box-shadow rounded-xg border-gris-100 project-card"
            }
          >
            <CardBody className="px-3 pb-1 pt-2">
              <Row className="h-100 ">
                <Col xs="12" className="mt-5 text-body">
                  <h1 className="mb-0 font-size-1 fw-600 text-center">
                    {name}
                  </h1>
                </Col>
                <Col xs="12" className="mb-0">
                  <Row className="h-100 justify-content-end align-items-end">
                    <Col xs="12" className="px-1 text-right">
                      <GenericTooltip msg={t("eliminarRol")}>
                        <Button
                          size="sm"
                          color="danger"
                          onClick={() => setConfirmDelete(true)}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </Button>
                      </GenericTooltip>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      )}
      <ConfirmationModal
        isOpen={confirmDelete}
        title={t("confirmeEliminacionRol")}
        closeButtonText={t("cancelar")}
        closeAction={() => setConfirmDelete(false)}
        primaryButtonText={t("confirmar")}
        primaryAction={deleteRole}
      >
        <p>
          <T i18nKey="mensajeEliminacionRol" />
        </p>
      </ConfirmationModal>
    </>
  );
};

export default ProjectRoleCard;
